// src/components/Payment.tsx
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store';
// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';
// const stripePromise = loadStripe('your-public-key-here'); // Replace with your actual Stripe public key

import { setBookingData } from '../../store/bookingSlice'; // Import your Redux action
import StripePayment from './StripePayment';
import PayPalPayment from './PaypalPayment';
import { createBankPayment } from '../../services/payments';

const Payment: React.FC<{ event: any, booth: any, prevStep: () => void }> = ({ event, booth, prevStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state: RootState) => state.booking.data);


  // State to manage the selected tab
  const [selectedTab, setSelectedTab] = useState<'stripe' | 'paypal' | 'bank_transfer'>(data.payment_method || 'stripe');
  const [bankTransferLoading, setBankTransferLoading] = useState(false);

  const handleTabClick = (method: 'stripe' | 'paypal' | 'bank_transfer') => {
    setSelectedTab(method);
    dispatch(setBookingData({ payment_method: method }));
  };

  const handleBankTransferSubmit = async () => {
    try {
      setBankTransferLoading(true);
      const amount = Math.floor(booth.cost * (1 + parseFloat(event.tax) / 100.0) * 100);
      const currency = event.currency;

      const result = await createBankPayment({
        primary_email: data.primary_email,
        amount,
        currency,
        event_id: event.id,
        booth_no: booth.no,
      });

      if (result && result.applicant) {
        // Redirect to invoice page similar to Stripe and PayPal
        const eventUrl = `/invoice?event=${event.id}&booth=${booth.no}`;
        navigate(eventUrl);
      }
    } catch (error: any) {
      console.error('Bank transfer submission failed:', error);
      setBankTransferLoading(false);
    }
  };

  return (
    <div className="flex flex-col [height:calc(100%-50px)]">
      <h2 className="text-2xl font-bold mb-4">Payment</h2>

      {/* Payment Method Tabs */}
      <div className="flex border-b mb-4">
        <button
          className={`py-2 px-4 text-sm font-medium ${selectedTab === 'stripe' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabClick('stripe')}
        >
          Stripe
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium ${selectedTab === 'paypal' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabClick('paypal')}
        >
          PayPal
        </button>
        <button
          className={`py-2 px-4 text-sm font-medium ${selectedTab === 'bank_transfer' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabClick('bank_transfer')}
        >
          Bank Transfer
        </button>
      </div>

      {/* Payment Method Forms */}
      <div className="flex-grow">
        {selectedTab === 'stripe' ? (
          // <Elements stripe={stripePromise}>
          <div className="p-4 border rounded">
            {/* Stripe Payment Form */}
            <StripePayment data={{
              ...data,
              email: data.primary_email,
              event_id: event.id,
              booth_no: booth.no,
              booth_cost: booth.cost,
              tax:  parseFloat(event.tax),
              currency: event.currency 
            }} />
          </div>
          // </Elements>
        ) : selectedTab === 'paypal' ? (
          <div className="p-4 border rounded">
            {/* PayPal Payment Form */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Purchase by PayPal</h2>
            <PayPalPayment data={{
              ...data,
              email: data.primary_email,
              event_id: event.id,
              booth_no: booth.no,
              booth_cost: booth.cost,
              tax:  parseFloat(event.tax),
              currency: event.currency 

            }} />
          </div>
        ) : (
          <div className="p-4 border rounded">
            {/* Bank Transfer Payment Form */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Purchase by Bank Transfer</h2>
            <div className="max-w-lg space-y-4 p-4 rounded-lg">
              <div>
                <h2 className="text-lg font-semibold text-gray-800">Notes:</h2>
                <ul className="text-sm text-gray-600 list-disc list-inside">
                  <li>Payment required before entry allowed.</li>
                  <li>Payment terms:</li>
                </ul>
                <div className="pl-6 text-sm text-gray-600">
                  <p>Full payment is due within 14 days of invoice date.</p>
                  <p>Full payment required prior to entry.</p>
                </div>
                <ul className="text-sm text-gray-600 list-disc list-inside">
                  <li>Information for bank transfer also detailed on the invoice.</li>
                </ul>
              </div>

              <div className="pt-5">
                <div className="text-sm text-gray-600">
                  Checkout via Bank Transfer, you will be forwarded an invoice for payment. Payment needs to be received prior to the order delivery.
                </div>
              </div>

              <button
                onClick={handleBankTransferSubmit}
                disabled={bankTransferLoading}
                className={`w-full mt-3 max-w-[240px] px-4 py-2 font-semibold text-white bg-blue-500 rounded-md shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300 ${bankTransferLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {bankTransferLoading ? 'Processing...' : 'Checkout now'}
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <p className="text-xl font-semibold mb-4">{event.terms_and_conditions}</p> */}
      {/* Navigation Buttons */}
      <div className="mt-auto flex justify-between p-4 border-t">
        <button className="bg-gray-200 text-gray-600 hover:bg-gray-300 px-4 py-2 rounded" onClick={prevStep}>
          Back
        </button>
        {/* Uncomment this when you have a "Proceed" action */}
        {/* <button className="bg-blue-500 text-white px-4 py-2 rounded">
          Proceed
        </button> */}
      </div>
    </div>
  );
};

export default Payment;
